import { NFCE_CANCELLATION_WINDOW_MINUTES } from "../constants";
import type { CommercialInvoiceResponseDTO } from "../types/commercial-invoice.types";

const MINUTE_IN_MS = 60_000;

export interface CancellationEligibility {
  allowed: boolean;
  reason: string;
  minutesLeft: number | null;
}

export function getCancellationEligibility(
  invoice: CommercialInvoiceResponseDTO,
  now: number = Date.now(),
): CancellationEligibility {
  if (invoice.status === "CANCELED") {
    return { allowed: false, reason: "Nota já cancelada", minutesLeft: null };
  }

  if (invoice.status !== "ISSUED") {
    return {
      allowed: false,
      reason: "Apenas notas autorizadas podem ser canceladas",
      minutesLeft: null,
    };
  }

  const issuedAt = invoice.issuedAt
    ? new Date(invoice.issuedAt).getTime()
    : NaN;
  if (Number.isNaN(issuedAt)) {
    return {
      allowed: false,
      reason:
        "Ainda não sabemos quando esta nota foi autorizada. Use Reconsultar antes de cancelar.",
      minutesLeft: null,
    };
  }

  const elapsedMinutes = (now - issuedAt) / MINUTE_IN_MS;
  const minutesLeft = Math.floor(
    NFCE_CANCELLATION_WINDOW_MINUTES - elapsedMinutes,
  );

  if (minutesLeft < 0) {
    return {
      allowed: false,
      reason: `O prazo de ${NFCE_CANCELLATION_WINDOW_MINUTES} minutos para cancelar esta nota já passou. Para corrigir, emita uma nota nova.`,
      minutesLeft: null,
    };
  }

  return {
    allowed: true,
    reason: `Cancelar nota — restam cerca de ${minutesLeft} min`,
    minutesLeft,
  };
}
